// === src/components/Loader.jsx ===
import React from "react";

const Loader = () => (
  <div className="absolute inset-0 z-20 flex flex-col items-center justify-center bg-white/80 dark:bg-black/50 rounded">
    <svg
      className="animate-spin-slow h-12 w-12 text-orange-500"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
      />
    </svg>
    <p className="mt-2 text-sm text-gray-500 dark:text-gray-300">Loading...</p>
  </div>
);

export default Loader;
